import React, { useState  } from 'react';
import { useLocation } from 'react-router'

import '../afrekenen/Afrekenen.css';

import { useSearchParams } from 'react-router-dom';


type Props = {}

const Confirmatie = (props: Props) => {
  const [ searchParams] = useSearchParams();

  return (
    <div className="Confirmatie">
<h2>{searchParams.get("redirect_status") === "succeeded" ? "Bestelling gelukt!" : "mislukt"}</h2>
<p>{searchParams.get("redirect_status") === "succeeded" ? "Bedankt om ons te steunen." : "Er is iets verkeerd gelopen"}</p>
<p>{searchParams.get("redirect_status") === "succeeded" ? "We appreciëren het enorm!" : "Gelieve nogmaals te proberen. Indien het blijft mislukken, contacteer iemand van de leiding."}</p>
    </div>
  );
}

export default Confirmatie;
